import { render, staticRenderFns } from "./IconPandora.vue?vue&type=template&id=8b6f23e0&"
import script from "./IconPandora.vue?vue&type=script&lang=js&"
export * from "./IconPandora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports